import { LayerModule } from '@core/app/constants/layer-module/layer-modules';
import layerManager from '@core/app/svgedit/layer/layerManager';
import { getData } from '@core/helpers/layer/layer-config-helper';

import { PRINT_AND_CUT_HIDDEN_ATTR, PRINT_AND_CUT_LAYER_ATTR } from '../constants';

/**
 * Cutting layer groups generated by a previous run, under `root` (the live
 * document by default, or a preview clone).
 */
export const getGeneratedCutLayers = (root: Document | Element = document): SVGGElement[] => [
  ...root.querySelectorAll<SVGGElement>(`g.layer[${PRINT_AND_CUT_LAYER_ATTR}]`),
];

/**
 * UV Print layer groups holding the user's design: visible ones plus those a
 * previous Finish hid and tagged; a user-hidden layer has no tag and stays
 * excluded. Generated cutting layers are output, never content — tracing them
 * would offset the new cut path from the old cut line.
 * @param exclude - extra layer to leave out (the cut layer picked in layer mode)
 */
export const getContentsLayers = (exclude?: null | SVGGElement): SVGGElement[] =>
  layerManager
    .getAllLayers()
    .map((layer) => layer.getGroup())
    .filter(
      (group) =>
        (group.getAttribute('display') !== 'none' || group.hasAttribute(PRINT_AND_CUT_HIDDEN_ATTR)) &&
        group !== exclude &&
        !group.hasAttribute(PRINT_AND_CUT_LAYER_ATTR) &&
        getData(group, 'module') === LayerModule.UV_PRINT,
    );
